import { createTheme } from './createTheme';
import hbuiTheme from './hbuiTheme';

const theme = createTheme(hbuiTheme, {
    cssVarsPrefix: 'hb'
});

export const vars = theme.cssVars;
export const cssDeclarations = theme.cssDeclarations.join('\n');

export default theme;
